import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster,
// you can change unregister() to register() below.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
